import { gql, useQuery } from "@apollo/client";
import useRequestConfig from "src/utils/hook/base/useRequestConfig";
import mainPermissionList from "../../config/MainPermissionListConfig";

//Schema definition
const Q_activeSiteList = gql`
  query activeSiteList {
    activeSiteList {
      edges {
        node {
          id
          name
          chain {
            standardCode
          }
          chains {
            edges {
              node {
                standardCode
              }
            }
          }
        }
      }
    }
  }
`;

function useActiveSiteList() {
  const { requestConfig } = useRequestConfig();
  const { loading, error, data } = useQuery(
    Q_activeSiteList,
    requestConfig({ module: "AVC_SITE", Microservice: mainPermissionList.activeSiteList })
  );
  return { loading, error, data };
}
export default useActiveSiteList;
